<template>
  <div ref="tooltip" class="tooltip">
    <div class="tooltip__container">
      <Icon icon="close" class="tooltip__close" @click="cancel" />
      <div class="tooltip__body">
        <p class="tooltip__title">
          При закрытии несохраненные данные пропадут!
        </p>
        <div class="form__buttons popup-btns">
          <button
            class="button button--s button-primary"
            type="button"
            @click="close"
          >
            Все равно закрыть
          </button>
          <button
            class="button button--s button-cancel"
            type="button"
            @click="cancel"
          >
            Остаться
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('popupResult', 'close');
    },
    cancel() {
      this.$emit('popupResult', 'cancel');
    }
  }
};
</script>

<style scoped>
.tooltip {
  position: fixed;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1060;
  background: rgba(0, 0, 0, 0.2);
}
.tooltip__container {
  position: relative;
  width: 330px;
}
</style>
